import { referenceMetricValueOrCompute } from "../sibling-value-getter/getter";
import { MetricsKind } from "../types";
import { TOTAL_RETAIL } from "./formula-total-retail";
import { UNITS } from "./formula-units";

/**
 //  * Formulas for Metrics
 //  *
 //  * @param factoryOptions
 //  *  - provided to `metricsValueGetterCreator`
 //  *  - untyped, easily allow for custom inputs needed for calculation
 //  * @param getterParams
 //  *  - default getterParams from AgGrid
 //  *  - has context and data etc to facilitate calculation
 //  * @returns
 //  *  - a numerical caculated metrics value
 //  */
export const AUR = ({ factoryOptions, getterParams }) => {
    const totalUnits = referenceMetricValueOrCompute(
        () => UNITS({ factoryOptions, getterParams }),
        getterParams,
        MetricsKind.UNITS
    );
    const totalRetail = referenceMetricValueOrCompute(
        () => TOTAL_RETAIL({ factoryOptions, getterParams }),
        getterParams,
        MetricsKind.TOTAL_RETAIL
    );
    if (totalUnits && totalRetail) {
        return totalRetail / totalUnits;
    }

    return undefined;
};
